import api from '@/lib/api';

export interface EmailSubscription {
  id: string;
  email: string;
  label: string | null;
  created_at: string;
}

export const emailSubscriptionsService = {
  async list(): Promise<EmailSubscription[]> {
    const res = await api.get('/email-subscriptions');
    return res.data?.data || [];
  },

  async add(email: string, label?: string): Promise<EmailSubscription> {
    const res = await api.post('/email-subscriptions', { email, label });
    return res.data?.data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/email-subscriptions/${id}`);
  },
};
